import {
    ADD_LANE_OFFER,
    SET_LANE_OFFERS,
    DELETE_LANE_OFFER
} from './actionTypes'

const initialState = []

export default (state = initialState, action) => {
    let currentOffers = state
    switch (action.type) {
        case SET_LANE_OFFERS: 
            return action.offers || initialState
        case ADD_LANE_OFFER:
            currentOffers = JSON.parse(JSON.stringify(currentOffers))
            currentOffers.push(action.offer)
            return currentOffers
        case DELETE_LANE_OFFER:
            currentOffers = JSON.parse(JSON.stringify(currentOffers))
            currentOffers = currentOffers.filter(o => o.id !== action.offer.id)
            return currentOffers
        default:
            return state
    }
}

export { initialState }